import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, KeyRound } from "lucide-react";
import { useAdmin } from "../context/AdminContext";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const { authed, login, checking } = useAdmin();
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checking) return null;
  if (authed) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/auth/check`, {}, { headers: { "X-Admin-Token": token } });
      login(token);
      toast.success("Welcome, admin");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid admin token", { description: err?.response?.data?.detail || "Please check and try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-neutral-50 rounded-3xl p-8 md:p-10">
        <div className="w-12 h-12 rounded-full bg-neutral-900 flex items-center justify-center text-white mx-auto">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="mt-5 font-display text-3xl font-black text-center">Admin Access</h1>
        <p className="mt-2 text-center text-sm text-neutral-500">Enter your admin token to manage Stealodeal.</p>

        <form onSubmit={onSubmit} className="mt-6 space-y-3">
          <div className="relative">
            <KeyRound className="absolute left-5 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
            <input
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Admin token"
              required
              className="w-full h-12 rounded-full border border-neutral-300 bg-white pl-12 pr-5 text-sm focus:outline-none focus:border-neutral-900"
              data-testid="admin-token-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#FF5A1F] hover:bg-neutral-900 text-white font-bold text-sm disabled:opacity-60 transition"
            data-testid="admin-login-btn"
          >
            {loading ? "Verifying..." : "Sign In"}
          </button>
        </form>

        <p className="mt-6 text-xs text-neutral-500 text-center">
          Restricted area · Unauthorized access is prohibited.
        </p>
      </div>
    </main>
  );
}
